import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { GlobalContext } from '../../../GlobalContext';

import InvoiceForm from '../../../Components/invoice/invoiceForm';

const Invoice = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Invoice');
    });

    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId = { userID: decodedToken.id }

    return (
        <div className="min-h-screen bg-gray-100">
            <div className="mx-auto max-w-7xl">
                <InvoiceForm />
            </div>
        </div>
    )
    
}

export default Invoice;